import { render, staticRenderFns } from "./FullSwapNotification.vue?vue&type=template&id=78679897&scoped=true"
import script from "./FullSwapNotification.vue?vue&type=script&lang=js"
export * from "./FullSwapNotification.vue?vue&type=script&lang=js"
import style0 from "./FullSwapNotification.vue?vue&type=style&index=0&id=78679897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78679897",
  null
  
)

export default component.exports